import React from 'react';

import './ChatLandingPage.scss';
import Chat from '../../Components/Chat/Chat';
// import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const ChatLandingPage = () => {
  // const { isLoggedin } = useSelector((state) => state.signInReducer);
  const [searchParams] = useSearchParams();
  
  const userEmail = searchParams.get('email') || JSON.parse(localStorage.getItem('userData'))?.email;
  const userToken = searchParams.get('token') || JSON.parse(localStorage.getItem('userData'))?.token;

  return (
    <>
      <Chat userEmail={userEmail} userToken={userToken} />
    </>
  );
};

export default ChatLandingPage;
